import React, { useState, } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { userLogin, forgotPasswords, verifyOtpAndSetPassword } from "../store/slices/auth";
import { useDispatch, } from "react-redux";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../assets/logo.png";
import { Modal, Form, Button } from "react-bootstrap";
import "../Login.css";


export default function LoginPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        username: "",
        password: "",
    });

    const [errors, setErrors] = useState({
        username: "",
        password: "",
    });

    const [showForgotModal, setShowForgotModal] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [forgotLoading, setForgotLoading] = useState(false);

    const [forgotForm, setForgotForm] = useState({
        email: "",
        mobileNumber: "",
        otp: "",
        newPassword: "",
    });
    const [forgotErrors, setForgotErrors] = useState({
        email: "",
        mobileNumber: "",
        otp: "",
        newPassword: "",
    });

    const [showPw, setShowPw] = useState(false);
    const [loading, setLoading] = useState(false);
    const [logoErr, setLogoErr] = useState(false);


    const validateField = (name, value) => {

        let error = "";

        if (name === "username") {

            if (!value.trim()) {

                error = "Please enter username";

            }
        }

        if (name === "password") {

            if (!value.trim()) {

                error = "Please enter password";

            }
        }

        return error;
    };


    const validateForgotForm = (isOtpStep = false) => {
        const errors = {
            email: validateForgotField("email", forgotForm.email),
            mobileNumber: validateForgotField(
                "mobileNumber",
                forgotForm.mobileNumber
            ),
            otp: "",
            newPassword: "",
        };

        if (isOtpStep) {
            errors.otp = validateForgotField(
                "otp",
                forgotForm.otp
            );

            errors.newPassword = validateForgotField(
                "newPassword",
                forgotForm.newPassword
            );
        }

        setForgotErrors(errors);

        return !Object.values(errors).some(Boolean);
    };

    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: validateField(name, value),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const usernameError = validateField(
            "username",
            form.username
        );

        const passwordError = validateField(
            "password",
            form.password
        );

        setErrors({
            username: usernameError,
            password: passwordError,
        });

        if (usernameError || passwordError) {
            return;
        }

        try {
            setLoading(true);

            const response = await dispatch(
                userLogin({
                    username: form.username,
                    password: form.password,
                })
            ).unwrap();

            const role =
                response?.role ||
                response?.data?.user?.role;

            console.log("ROLE:", role);

            if (role === "user") {

                navigate("/user/home");

            } else if (role === "admin") {

                navigate("/admin/home");

            } else {

                console.log("No matching role");
            }

        } catch (error) {
            console.log(error);

            alert(
                error || "Login failed"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleForgotChange = (e) => {
        const { name, value } = e.target;

        let finalValue = value;

        if (name === "mobileNumber") {
            finalValue = value.replace(/\D/g, "").slice(0, 10);
        }

        if (name === "otp") {
            finalValue = value.replace(/\D/g, "").slice(0, 6);
        }

        setForgotForm((prev) => ({
            ...prev,
            [name]: finalValue,
        }));

        // validate on typing
        setForgotErrors((prev) => ({
            ...prev,
            [name]: validateForgotField(name, finalValue),
        }));
    };

    const handleSendOtp = async () => {
        if (!validateForgotForm()) {
            return;
        }

        try {
            setForgotLoading(true);

            const response = await dispatch(
                forgotPasswords({
                    email: forgotForm.email,
                    mobileNumber: forgotForm.mobileNumber,
                })
            ).unwrap();

            setOtpSent(true);
        } catch (error) {
            alert(error);
        } finally {
            setForgotLoading(false);
        }
    };

    const handleResetPassword = async () => {
        if (!validateForgotForm(true)) {
            return;
        }

        try {
            setForgotLoading(true);

            const response = await dispatch(
                verifyOtpAndSetPassword({
                    email: forgotForm.email,
                    mobileNumber: forgotForm.mobileNumber,
                    otp: forgotForm.otp,
                    newPassword: forgotForm.newPassword,
                })
            ).unwrap();

            alert(response || "Password reset successfully");
            setShowForgotModal(false);
        } catch (error) {
            alert(error);
        } finally {
            setForgotLoading(false);
        }
    };
    const validateForgotField = (name, value) => {
        let error = "";

        switch (name) {
            case "email":
                if (!value.trim()) {
                    error = "Please enter email";
                } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
                ) {
                    error = "Please enter a valid email";
                }
                break;

            case "mobileNumber":
                if (!value.trim()) {
                    error = "Please enter mobile number";
                } else if (!/^[6-9]\d{9}$/.test(value)) {
                    error = "Please enter a valid 10-digit mobile number";
                }
                break;

            case "otp":
                if (!value.trim()) {
                    error = "Please enter OTP";
                }
                break;

            case "newPassword":
                if (!value.trim()) {
                    error = "Please enter new password";
                } else if (value.length < 6) {
                    error = "Password must be at least 6 characters";
                }
                break;

            default:
                break;
        }

        return error;
    };



    return (
        <>



            <div className="sar-page">

                <div className="sar-card">

                    {/* LOGO */}

                    <div className="sar-logo-wrap">

                        <div className="sar-logo-img-box">

                            {logoErr ? (

                                <span className="sar-logo-fallback">
                                    CB
                                </span>

                            ) : (

                                <img
                                    src={logo}
                                    alt="logo"
                                    className="sar-logo-img"
                                    onError={() => setLogoErr(true)}
                                />

                            )}

                        </div>

                        <div className="sar-brand">
                            Cash Back Promoters and Developers
                        </div>


                    </div>

                    <div className="sar-accent-line"></div>

                    {/* TITLE */}

                    <div className="sar-form-title">
                        Login
                    </div>




                    <form onSubmit={handleSubmit}>



                        <div className="sar-field">

                            <label className="sar-label">
                                Username
                            </label>

                            <div className="sar-input-wrap">



                                <input
                                    type="text"
                                    name="username"
                                    placeholder="Enter username"
                                    value={form.username}
                                    onChange={handleChange}
                                    disabled={loading}
                                    className={`sar-input ${errors.username ? "sar-input-invalid" : ""}`}
                                    maxLength={30}
                                />

                            </div>

                            {errors.username && (

                                <div className="sar-input-error">
                                    {errors.username}
                                </div>

                            )}

                        </div>

                        {/* PASSWORD */}

                        <div className="sar-field">

                            <label className="sar-label">
                                Password
                            </label>

                            <div className="sar-input-wrap">



                                <input
                                    type={showPw ? "text" : "password"}
                                    name="password"
                                    placeholder="Enter password"
                                    value={form.password}
                                    onChange={handleChange}
                                    disabled={loading}
                                    className={`sar-input ${errors.password ? "sar-input-invalid" : ""}`}
                                    maxLength={25}
                                />

                                <button
                                    type="button"
                                    className="sar-pw-toggle"
                                    onClick={() =>
                                        setShowPw(!showPw)
                                    }
                                >
                                    {showPw
                                        ? <FaEyeSlash />
                                        : <FaEye />
                                    }
                                </button>

                            </div>

                            {errors.password && (

                                <div className="sar-input-error">
                                    {errors.password}
                                </div>

                            )}

                        </div>

                        {/* EXTRA */}

                        <div className="sar-extras">
                            <button
                                type="button"
                                className="sar-forgot"
                                onClick={() => setShowForgotModal(true)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    cursor: "pointer",
                                }}
                            >
                                Forgot Password?
                            </button>

                        </div>

                        {/* BUTTON */}

                        <button
                            type="submit"
                            className="sar-btn"
                            disabled={loading}
                        >

                            {loading ? (

                                <>
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        style={{
                                            marginRight: 8
                                        }}
                                    />

                                    Please wait...

                                </>

                            ) : (

                                "Login"

                            )}

                        </button>

                    </form>


                    <div className="sar-register">

                        Don't have an account?

                        <span
                            onClick={() => navigate("/register")}
                            className="sar-register-link"
                        >
                            Register
                        </span>

                    </div>
                    {/* FOOTER */}


                </div>

            </div>
            <Modal
                show={showForgotModal}
                onHide={() => {
                    setShowForgotModal(false);
                    setOtpSent(false);
                }}
                centered
                size="md"
            >
                <Modal.Header
                    closeButton
                    style={{
                        background: "linear-gradient(135deg, #D32F2F, #B71C1C)",
                        color: "#fff",
                        border: "none",
                    }}
                >
                    <Modal.Title
                        style={{
                            fontWeight: 700,
                            fontSize: "1.25rem",
                        }}
                    >
                        🔐 Reset Password
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body
                    style={{
                        padding: "30px",
                        background: "#fafafa",
                    }}
                >
                    <div className="text-center mb-4">
                        <div
                            style={{
                                width: 70,
                                height: 70,
                                margin: "0 auto",
                                borderRadius: "50%",
                                background: "#ffe5e5",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 30,
                            }}
                        >
                            🔑
                        </div>

                        <h5
                            style={{
                                marginTop: 15,
                                fontWeight: 700,
                                color: "#333",
                            }}
                        >
                            Forgot Your Password?
                        </h5>

                        <p
                            style={{
                                color: "#777",
                                fontSize: "14px",
                                marginBottom: 0,
                            }}
                        >
                            Enter your registered email and mobile number.
                        </p>
                    </div>

                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: 600 }}>
                            Email Address
                        </Form.Label>

                        <Form.Control
                            type="email"
                            name="email"
                            value={forgotForm.email}
                            onChange={handleForgotChange}
                            disabled={otpSent}
                            placeholder="Enter registered email"
                            style={{
                                height: 50,
                                borderRadius: 12,
                            }}
                        />
                        {forgotErrors.email && (
                            <div className="text-danger mt-1">
                                {forgotErrors.email}
                            </div>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: 600 }}>
                            Mobile Number
                        </Form.Label>

                        <Form.Control
                            type="text"
                            name="mobileNumber"
                            value={forgotForm.mobileNumber}
                            onChange={handleForgotChange}
                            disabled={otpSent}
                            placeholder="Enter registered mobile number"
                            style={{
                                height: 50,
                                borderRadius: 12,
                            }}
                        />
                        {forgotErrors.mobileNumber && (
                            <div className="text-danger mt-1">
                                {forgotErrors.mobileNumber}
                            </div>
                        )}
                    </Form.Group>

                    {otpSent && (
                        <>
                            <div
                                style={{
                                    background: "#e8f5e9",
                                    color: "#2e7d32",
                                    padding: "12px",
                                    borderRadius: 10,
                                    marginBottom: 20,
                                    textAlign: "center",
                                    fontWeight: 600,
                                }}
                            >
                                OTP sent successfully ✓
                            </div>

                            <Form.Group className="mb-3">
                                <Form.Label style={{ fontWeight: 600 }}>
                                    Verification OTP
                                </Form.Label>

                                <Form.Control
                                    type="text"
                                    name="otp"
                                    value={forgotForm.otp}
                                    onChange={handleForgotChange}
                                    placeholder="Enter OTP"
                                    style={{
                                        height: 50,
                                        borderRadius: 12,
                                        letterSpacing: "4px",
                                        textAlign: "center",
                                        fontWeight: 700,
                                    }}
                                />
                                {forgotErrors.otp && (
                                    <div className="text-danger mt-1">
                                        {forgotErrors.otp}
                                    </div>
                                )}
                            </Form.Group>

                            <Form.Group>
                                <Form.Label style={{ fontWeight: 600 }}>
                                    New Password
                                </Form.Label>

                                <Form.Control
                                    type="password"
                                    name="newPassword"
                                    value={forgotForm.newPassword}
                                    onChange={handleForgotChange}
                                    placeholder="Enter new password"
                                    style={{
                                        height: 50,
                                        borderRadius: 12,
                                    }}
                                />
                                {forgotErrors.newPassword && (
                                    <div className="text-danger mt-1">
                                        {forgotErrors.newPassword}
                                    </div>
                                )}
                            </Form.Group>
                        </>
                    )}
                </Modal.Body>

                <Modal.Footer
                    style={{
                        border: "none",
                        padding: "20px 30px",
                        background: "#fafafa",
                    }}
                >
                    {!otpSent ? (
                        <Button
                            onClick={handleSendOtp}
                            disabled={forgotLoading}
                            style={{
                                width: "100%",
                                height: 50,
                                borderRadius: 12,
                                border: "none",
                                fontWeight: 700,
                                background:
                                    "linear-gradient(135deg, #D32F2F, #B71C1C)",
                            }}
                        >
                            {forgotLoading ? (
                                <>
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        style={{ marginRight: 8 }}
                                    />
                                    Sending OTP...
                                </>
                            ) : (
                                "Send OTP"
                            )}
                        </Button>
                    ) : (
                        <Button
                            onClick={handleResetPassword}
                            disabled={forgotLoading}
                            style={{
                                width: "100%",
                                height: 50,
                                borderRadius: 12,
                                border: "none",
                                fontWeight: 700,
                                background:
                                    "linear-gradient(135deg, #2E7D32, #1B5E20)",
                            }}
                        >
                            {forgotLoading ? (
                                <>
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        style={{ marginRight: 8 }}
                                    />
                                    Resetting...
                                </>
                            ) : (
                                "Reset Password"
                            )}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

        </>
    );
}